import React, { useState , useEffect} from "react";
import { Link } from "react-router-dom";
import { FaUser, FaLock, FaEye, FaEyeSlash } from "react-icons/fa";
import useAuthService from "../hooks/useAuthService";

import "../styles/Login.css";
import logo from "../assets/logo512.png";

  function Login() {

    const { login, checkRefreshToken } = useAuthService();

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState("");

    useEffect(() => {
      const verifyToken = async () => {
        const isValid = await checkRefreshToken(); // Call API to validate token
        if (isValid) {
          console.log("Valid token found");
        } 
      };
      verifyToken();
    }, [checkRefreshToken]); // Runs once when the component mounts
  
  
    const handleLogin = async (e) => {
      e.preventDefault();
      setError("");
  
      try {
        await login(email, password);
        // navigate("/upload");

      } catch (err) {
        setError(`Invalid credentials. Please try again. ${err}`);
      }
    };

  return (
    <div className="login-page">
      <div className="login-container">
        {/* Logo */}
        <img src={logo} alt="Company Logo" className="logo" />

        {/* Login Form */}
        <form onSubmit={handleLogin}>
          {error && <p className="error">{error}</p>}

          <div className="input-group">
            <FaUser className="icon" />
            <input
              type="email"
              placeholder="Email Address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="input-group password-group">
            <FaLock className="icon" />
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <button 
                  type="button" 
                  className="toggle-password" 
                  onClick={() => setShowPassword(!showPassword)}
              >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
          </div>

          <button type="submit">Login</button>
        </form>

        {/* Footer Links */}
        <div className="footer-links">
          <span>Not a member? <Link to="/register">Sign Up</Link></span>
        </div>
      </div>
    </div>
  );
}

export default Login;